import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActivityTrackingService } from './activity-tracking.service';

/**
 * Observes V1 business API calls and enqueues activity events.
 * Uses Injector lazily to avoid HttpClient <-> interceptor circular DI
 * (which can break app bootstrap / login).
 */
@Injectable()
export class ActivityApiInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      const url = request.url || '';
      if (
        url.includes('/other/logactivity') ||
        url.includes('/other/logevent') ||
        url.includes('/auth/refresh') ||
        url.includes('/auth/login') ||
        url.includes('/auth1/login') ||
        url.includes('/auth1/logout') ||
        url.includes('/auth1/startsession') ||
        url.includes('/auth1/checksession') ||
        url.includes('/custom-login') ||
        url.includes('-v2-')
      ) {
        return next.handle(request);
      }
      // Lazy resolve — never inject ActivityTrackingService in constructor
      const activity = this.injector.get(ActivityTrackingService, null);
      activity?.trackApiCall(request.method, url);
    } catch {
      /* never block HTTP / login */
    }
    return next.handle(request);
  }
}
